import { Avatar } from '@mentimeter/ragnar-ui/avatar';

export function UserMenuLoading() {
  return <Avatar initials=" " name="" type="user" size="large" />;
}
